export type FilterCategoryType<T> = {
  id: string;
  render: string;
  filters?: string[];
  filtersRenders?: T[];
};

export function hasSelectedFilters(selectedFiltersArray: FilterCategoryType<unknown>[]) {
  return selectedFiltersArray.reduce((acc, cur) => acc + cur.filters.length, 0) > 0;
}

export function getCategoryFilters<T>(filterCat: string, selectedFiltersArray: FilterCategoryType<T>[]): T[] | null {
  const categoryFilters = selectedFiltersArray.find((cat) => cat.id === filterCat);
  if (categoryFilters && categoryFilters.filters.length > 0) {
    return categoryFilters.filters as T[];
  }
  return null;
}
